/* eslint-disable no-param-reassign */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TabInfo } from 'src/components/MultiTab';

const initialTabs: TabInfo[] = [
  {
    label: 'JOB LIST',
    to: '/job-requisition/job-list',
    closeable: false,
  },
];

const jobRequisitionTabs = createSlice({
  name: 'jobRequisitionTabs',
  initialState: initialTabs,
  reducers: {
    updateTab: (state, action: PayloadAction<TabInfo>) => {
      const alreadyExists = state.find((item) => item.jobOrderId === action.payload.jobOrderId);
      if (!alreadyExists) {
        state.push(action.payload);
      }
    },
    onTabClose: (state, action: PayloadAction<string | number | undefined>) => {
      if (action.payload) {
        const index = state.findIndex((item) => item.jobOrderId === Number(action.payload));
        state.splice(index, 1);
      }
    },
  },
});

export const {
  updateTab,
  onTabClose,
} = jobRequisitionTabs.actions;

export default jobRequisitionTabs;
